export enum EProductsListTabName {
  ALL = 'all',
  CONNECTED = 'connected',
  NOT_CONNECTED = 'not_connected',
  IGNORED = 'ignored',
  DRAFTS = 'drafts',
}
